import { useUtmParams } from 'pages/register/ui/Register/hooks/useUtmParams'
import { Register } from './Register'

export const RegisterPage = () => {
  useUtmParams()

  return <Register />
}

export default RegisterPage
